export default __webpack_public_path__ + "static/media/whiskey.c0ed9615.webp";